import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet-async";
import apiClient from "../api/apiClient"; // make sure axios instance supports cancelToken
import axios from "axios";
const AchatExternalise = () => {
  const [formData, setFormData] = useState({
    nomProduit: "",
    description: "",
    quantiteDemandee: "",
    nomCompagnie: "",
    adresseEmail: "",
    numeroTel: "",
    localite: "",
    nomClient: "",
    prenomClient: "",
  });
  const [image, setImage] = useState(null);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [retryCount, setRetryCount] = useState(0);

  const idClient = 1; // replace with actual client ID

  const validateForm = () => {
    const newErrors = {};

    if (!formData.nomProduit.trim())
      newErrors.nomProduit = "Le nom du produit est requis.";
    if (!formData.nomCompagnie.trim())
      newErrors.nomCompagnie = "Le nom de la compagnie est requis.";

    if (!formData.adresseEmail.trim()) {
      newErrors.adresseEmail = "L'email est requis.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.adresseEmail)) {
      newErrors.adresseEmail = "Format d'email invalide.";
    }

    if (!formData.numeroTel.trim()) {
      newErrors.numeroTel = "Le numéro de téléphone est requis.";
    } else if (!/^[+]?[0-9\s\-\(\)]{8,}$/.test(formData.numeroTel)) {
      newErrors.numeroTel = "Format de téléphone invalide.";
    }

    if (!formData.nomClient.trim()) {
      newErrors.nomClient = "Le nom du client est requis.";
    }

    if (!formData.prenomClient.trim()) {
      newErrors.prenomClient = "Le prénom du client est requis.";
    }

    if (
      !formData.quantiteDemandee ||
      isNaN(formData.quantiteDemandee) ||
      parseFloat(formData.quantiteDemandee) <= 0
    ) {
      newErrors.quantiteDemandee =
        "La quantité demandée doit être un nombre valide supérieur à zéro.";
    }

    if (!image) {
      newErrors.image = "Une image est requise.";
    } else {
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
        "image/webp",
      ];
      if (!allowedTypes.includes(image.type)) {
        newErrors.image =
          "Format non supporté. Utilisez JPEG, PNG, GIF ou WebP.";
      }
      if (image.size > 5 * 1024 * 1024) {
        newErrors.image = "Le fichier est trop volumineux (max 5MB).";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    if (errors.image) setErrors((prev) => ({ ...prev, image: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setSuccessMessage("");

    let timeoutId;
    try {
      const submitData = new FormData();
      submitData.append("id_client", idClient);
      submitData.append("nom_produit", formData.nomProduit);
      submitData.append("description", formData.description);
      submitData.append("quantite_demandee", formData.quantiteDemandee);
      submitData.append("nom_compagnie", formData.nomCompagnie);
      submitData.append("adresse_email", formData.adresseEmail);
      submitData.append("numero_tel", formData.numeroTel);
      submitData.append("localite", formData.localite);
      submitData.append("nom_client", formData.nomClient);
      submitData.append("prenom_client", formData.prenomClient);
      submitData.append("image", image);

      // Create cancel token
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();

      timeoutId = setTimeout(() => {
        source.cancel("Le délai d'attente est dépassé.");
      }, 30000); // 30s timeout

      const response = await apiClient.post("/achatexternalise", submitData, {
        headers: { "Content-Type": "multipart/form-data" },
        cancelToken: source.token,
      });

      clearTimeout(timeoutId);

      setSuccessMessage(
        response.data.message ||
          "Votre demande a été envoyée avec succès ! Nous vous recontacterons rapidement.",
      );

      setFormData({
        nomProduit: "",
        description: "",
        quantiteDemandee: "",
        nomCompagnie: "",
        adresseEmail: "",
        numeroTel: "",
        localite: "",
        nomClient: "",
        prenomClient: "",
      });
      setImage(null);
      setErrors({});
      setRetryCount(0);
    } catch (error) {
      if (timeoutId) clearTimeout(timeoutId);

      let errorMsg = "Erreur lors de l'envoi de votre demande.";

      if (axios.isCancel(error)) {
        errorMsg = "Délai dépassé ou requête annulée. Veuillez réessayer.";
      } else if (error.response) {
        if (error.response.status === 422) {
          errorMsg = "Données invalides. Vérifiez vos informations.";
        } else if (error.response.status >= 500) {
          errorMsg = "Erreur serveur. Réessayez plus tard.";
        } else {
          errorMsg =
            error.response.data?.message || `Erreur ${error.response.status}`;
        }
      } else if (error.request) {
        errorMsg = "Problème de connexion. Vérifiez votre internet.";
      }

      setErrors({ submit: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  const handleRetry = () => {
    setRetryCount((prev) => prev + 1);
    setErrors({});
  };

  return (
    <>
      <Helmet>
        <title>Demande d'Achat Externalisé | DVELGE Fourniture</title>
        <meta
          name="description"
          content="Soumettez vos demandes d'achat externalisé pour des produits non disponibles avec DVELGE Fourniture à Conakry, Guinée."
        />
      </Helmet>

      <div className="container d-flex justify-content-center mt-5">
        <div className="w-100" style={{ maxWidth: "600px" }}>
          <h1 className="text-center mb-4">Demande d'achat Externalisé</h1>

          {errors.submit && (
            <div className="alert alert-danger d-flex align-items-center">
              <div className="flex-grow-1">{errors.submit}</div>
              {retryCount < 3 && (
                <button
                  className="btn btn-sm btn-outline-primary ms-2"
                  onClick={handleRetry}
                  disabled={loading}
                >
                  {loading ? "Envoi..." : "Réessayer"}
                </button>
              )}
            </div>
          )}

          {successMessage && (
            <div className="alert alert-success">{successMessage}</div>
          )}

          <form
            onSubmit={handleSubmit}
            className="shadow p-4 rounded bg-light"
            noValidate
          >
            {/* Nom et Prénom du Client */}
            <div className="row g-3 mb-3">
              <div className="col-md-6">
                <label className="form-label">Nom *</label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.nomClient ? "is-invalid" : ""
                  }`}
                  name="nomClient"
                  value={formData.nomClient}
                  onChange={handleChange}
                />
                {errors.nomClient && (
                  <div className="invalid-feedback">{errors.nomClient}</div>
                )}
              </div>
              <div className="col-md-6">
                <label className="form-label">Prénom *</label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.prenomClient ? "is-invalid" : ""
                  }`}
                  name="prenomClient"
                  value={formData.prenomClient}
                  onChange={handleChange}
                />
                {errors.prenomClient && (
                  <div className="invalid-feedback">{errors.prenomClient}</div>
                )}
              </div>
            </div>

            {/* Nom Produit */}
            <div className="mb-3">
              <label htmlFor="nomProduit" className="form-label">
                Nom du Produit *
              </label>
              <input
                type="text"
                className={`form-control ${
                  errors.nomProduit ? "is-invalid" : ""
                }`}
                name="nomProduit"
                value={formData.nomProduit}
                onChange={handleChange}
              />
              {errors.nomProduit && (
                <div className="invalid-feedback">{errors.nomProduit}</div>
              )}
            </div>

            {/* Description */}
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                name="description"
                value={formData.description}
                onChange={handleChange}
                rows="3"
              />
            </div>

            {/* Quantité et Compagnie */}
            <div className="row g-3 mb-3">
              <div className="col-md-6">
                <label className="form-label">Quantité Demandée *</label>
                <input
                  type="number"
                  className={`form-control ${
                    errors.quantiteDemandee ? "is-invalid" : ""
                  }`}
                  name="quantiteDemandee"
                  value={formData.quantiteDemandee}
                  onChange={handleChange}
                  min="1"
                />
                {errors.quantiteDemandee && (
                  <div className="invalid-feedback">
                    {errors.quantiteDemandee}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label className="form-label">Nom de la Compagnie *</label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.nomCompagnie ? "is-invalid" : ""
                  }`}
                  name="nomCompagnie"
                  value={formData.nomCompagnie}
                  onChange={handleChange}
                />
                {errors.nomCompagnie && (
                  <div className="invalid-feedback">{errors.nomCompagnie}</div>
                )}
              </div>
            </div>

            {/* Email et Téléphone */}
            <div className="row g-3 mb-3">
              <div className="col-md-6">
                <label className="form-label">Email *</label>
                <input
                  type="email"
                  className={`form-control ${
                    errors.adresseEmail ? "is-invalid" : ""
                  }`}
                  name="adresseEmail"
                  value={formData.adresseEmail}
                  onChange={handleChange}
                />
                {errors.adresseEmail && (
                  <div className="invalid-feedback">{errors.adresseEmail}</div>
                )}
              </div>
              <div className="col-md-6">
                <label className="form-label">Numéro de Téléphone *</label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.numeroTel ? "is-invalid" : ""
                  }`}
                  name="numeroTel"
                  value={formData.numeroTel}
                  onChange={handleChange}
                />
                {errors.numeroTel && (
                  <div className="invalid-feedback">{errors.numeroTel}</div>
                )}
              </div>
            </div>

            {/* Localité */}
            <div className="mb-3">
              <label className="form-label">Localité</label>
              <input
                type="text"
                className="form-control"
                name="localite"
                value={formData.localite}
                onChange={handleChange}
              />
            </div>

            {/* Image */}
            <div className="mb-3">
              <label className="form-label">Image du Produit *</label>
              <input
                type="file"
                className={`form-control ${errors.image ? "is-invalid" : ""}`}
                onChange={handleImageChange}
                accept=".jpg,.jpeg,.png,.gif,.webp"
              />
              {errors.image && (
                <div className="invalid-feedback">{errors.image}</div>
              )}
              {image && !errors.image && (
                <small className="text-success">
                  Fichier sélectionné: {image.name}
                </small>
              )}
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? "Envoi..." : "Soumettre la demande"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default AchatExternalise;
